import { BOOK_URL, ASSETS } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#050505] pt-20 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-heading font-extrabold tracking-tighter text-2xl">
              LEAK<span className="text-[#169ED9]">·</span>SMART SHIELD
            </div>
            <p className="mt-4 text-white/45 max-w-sm leading-relaxed text-sm">
              AI water protection by GWA Water Solutions, supplied &amp; installed by The Plumbing
              &amp; Electrical Co — a <span className="text-white/70">Caroma trained
              Installer</span>. Stop leaks before they start.
            </p>
            <a
              href="https://www.tpeco.com.au"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-website-link"
              className="mt-4 inline-block font-mono text-xs uppercase tracking-[0.15em] text-[#169ED9] hover:text-white transition-colors duration-300"
            >
              tpeco.com.au →
            </a>
            <a
              href={BOOK_URL}
              data-testid="footer-book-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-black px-6 py-3 text-sm font-semibold hover:bg-[#169ED9] transition-colors duration-300"
            >
              Book Free Assessment →
            </a>
            <div className="mt-8 flex items-center gap-5" data-testid="footer-partner-logos">
              <img
                src={ASSETS.logoStackedBlack}
                alt="Leak SmartShield by Caroma"
                data-testid="footer-brand-logo"
                className="h-14 w-auto object-contain opacity-90 [filter:brightness(0)_invert(1)]"
              />
              <span className="h-12 w-px bg-white/15" />
              <img
                src={ASSETS.tpecoWithLicense}
                alt="The Plumbing & Electrical Co. — licensed"
                data-testid="footer-tpeco-logo"
                className="h-20 w-20 object-contain opacity-90"
              />
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              Explore
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["The Valve", "#valve"],
                ["How It Works", "#how"],
                ["Features", "#features"],
                ["Pricing", "#pricing"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a href={h} className="text-white/60 hover:text-white transition-colors duration-300">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              Licences
            </div>
            <ul className="mt-5 space-y-2 font-mono text-xs text-white/50">
              <li data-testid="plumbing-licence">Plumbing Licence — PL8061</li>
              <li>BFL: 2246</li>
              <li>EC: 17738</li>
              <li>GL: 013140</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/35">
            © {new Date().getFullYear()} The Plumbing &amp; Electrical Co. — Perth, WA · PL8061
          </p>
          <a
            href="https://www.tpeco.com.au"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-website-bottom"
            className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/50 hover:text-[#169ED9] transition-colors duration-300"
          >
            tpeco.com.au
          </a>
        </div>
      </div>
    </footer>
  );
}
